import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { UserService } from "../../user/services/user.service";
import { Store } from "@ngrx/store";
import { ToastService } from "../../shared/services/toast.service";
import { TranslateService } from "@ngx-translate/core";
import { UsageTimerService } from "../../shared/services/usageTimer.service";
import { timerActions } from "./timer.actions";
import { catchError, map, of, switchMap } from "rxjs";
import { userActions } from "../../user/store/user.actions";

@Injectable()
export class TimerEffects {  
  
    constructor(private actions$: Actions, 
        private userService: UserService, 
        private store: Store,
        private toastService: ToastService,
        private translate: TranslateService,
        private timerService: UsageTimerService) {
    }    

    updateTimer$ = createEffect(() => this.actions$.pipe(
        ofType(timerActions.updateTimer),
        switchMap((action) =>
          this.timerService.updateTimer().pipe(
            map(expired => {
                if (expired) {
                    this.store.dispatch(userActions.logout());
                }
              return timerActions.updateTimerSuccess(true);
            }),            
            catchError(() => {
              return of (timerActions.updateTimerFailure({ error: 'Invalid credentials' }));
            })
          )
        )
    ));
  
}